<div class="masthead-products-sleeve-category">
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
      <h2 class="h3 m-b-8 d-block d-sm-none" [innerHTML]="resourcestrings['Aon.Category.CategoryTitle'] | safeHtml"></h2>
      <h2 class="h3 m-b-16 d-none d-sm-block" [innerHTML]="resourcestrings['Aon.Category.CategoryTitle'] | safeHtml"></h2>
      <p class="xl d-none d-sm-block m-b-0"
      [innerHTML]="resourcestrings['Aon.Category.CategoryIntro'] | safeHtml"></p>
      <p class="d-block d-sm-none m-b-20"
      [innerHTML]="resourcestrings['Aon.Category.CategoryIntro'] | safeHtml"></p>

    </div>

    @for (category of categories; track category) {
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
        <div class="category-column" aria-labelledby="{{category.itemTitle}}">
          <div class="d-flex align-items-center m-b-12">
            @if (category.image) {
              <div class="category-icon" [ngStyle]="{'background-image': 'url(' + category.image + ')'}" aria-hidden="true">
              </div>
            }
            <h3 class="h5 m-b-0 d-none d-sm-block">
              <a [attr.aria-label]="resourcestrings['Aon.Category.BrowseCategory'] + ' ' + category.itemTitle" (click)="goToCategory(category); hidePopup();"
                (keydown.enter)="goToCategory(category); hidePopup();"
              [innerHTML]="category.itemTitle | safeHtml" class="p-0 focus-visibility" tabindex="0" (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : null" (keyup.space)="$event.target === $event.currentTarget ? $any($event.target).click() : null" role="button"></a>
            </h3>
            <p class="lg m-b-0 d-block d-sm-none">
              <a [attr.aria-label]="resourcestrings['Aon.Category.BrowseCategory'] + ' ' + category.itemTitle" (click)="goToCategory(category); hidePopup();" [innerHTML]="category.itemTitle | safeHtml" class="p-0 focus-visibility" tabindex="0"  role="button" (keydown.enter)="$event.target === $event.currentTarget ? $any($event.target).click() : null" (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : null" (keyup.space)="$event.target === $event.currentTarget ? $any($event.target).click() : null"></a>
            </p>
          </div>
          <p class="lg m-b-20 d-none d-sm-block" [innerHTML]="category.itemSummary | safeHtml">
          </p>
          <p class="m-l-ss m-b-12 d-block d-sm-none"
            [innerHTML]="category.itemSummary | safeHtml">
          </p>
          <!-- Show all the External Products Related to a Category -->
          @for (product of category.products; track product; let last = $last) {
            <div class="category-products"
              [ngClass]="{'m-b-16': last !== true}">
              <p class="m-b-0 d-none d-sm-block">
                <a (click)="goToProduct(product); hidePopup();"
                  (keydown.enter)="goToProduct(product); hidePopup();"
                [innerHTML]="product.itemTitle | safeHtml" class="d-inline p-0 focus-visibility" tabindex="0" (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : null" (keyup.space)="$event.target === $event.currentTarget ? $any($event.target).click() : null" role="button"></a>
              </p>
              <p class="m-b-0 m-l-ss sm d-block d-sm-none">
                <a (click)="goToProduct(product); hidePopup();"
                  (keydown.enter)="goToProduct(product); hidePopup();"
                [innerHTML]="product.itemTitle | safeHtml" class="d-inline p-0 focus-visibility" tabindex="0" (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : null" (keyup.space)="$event.target === $event.currentTarget ? $any($event.target).click() : null" role="button"></a>
              </p>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
